import { spaceConstants } from "../constants";


export function space(state = { loading: false }, action) {
    switch (action.type) {
        case spaceConstants.GET_REQUEST:
            return {
                spaceList: "",
                loading: true
            };
        case spaceConstants.GET_SUCCESS:
            // console.log(action.payload)
            return {
                spaceList: action.payload,
                loading: false
            };
        case spaceConstants.GET_FAILURE:
            // console.log(action.payload)
            return {
                error: action.payload,
                spaceList: "",
                loading: false,
                done: true
            };
        case spaceConstants.GET_FAILURE_DONE:
            return {
                error: Object.keys({ ...state.error }).length === 0 ? "" : { ...state.error },
                spaceList: "",
                loading: false,
                done: false
            };
        default:
            // console.log("in default")
            // console.log(state)
            return state;
    }
}